import React from 'react';

const CategoriesHeader = () => {
    return (
        <h1>Categories</h1>
    );
};

export default CategoriesHeader;
